// libs
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// shared components
import { RefreshIcon, CheckmarkCircleIcon } from 'components/library';

import './loader-button.scss';

export default class LoaderButton extends React.Component {
    static propTypes = {
        disabled: PropTypes.bool,
        fetching: PropTypes.bool,
        handleClick: PropTypes.func.isRequired,
        tabIndex: PropTypes.number,
        customClass: PropTypes.string,
        children: PropTypes.node,
        done: PropTypes.bool,
        branding: PropTypes.bool,
        clientBranding: PropTypes.bool,
        brandingInverted: PropTypes.bool
    };
    static defaultProps = {
        branding: false,
        clientBranding: false,
        brandingInverted: false
    };

    handleClick = ( e ) => {
        e.preventDefault();
        if ( !this.props.disabled ) {
            this.props.handleClick();
        }
    }

    render() {
        const {
            disabled,
            fetching,
            handleClick, // eslint-disable-line no-unused-vars
            tabIndex,
            customClass,
            children,
            done,
            branding,
            clientBranding,
            brandingInverted,
            ...props
        } = this.props;
        const isFetching = !done && fetching;
        const styles = {
            'gq-btn': true,
            'btn': true,
            'fetching': isFetching,
            'disabled': disabled,
            'done': done,
            'branding-primary-button': branding,
            'client-primary-button': clientBranding,
            'branding-primary-button-inverted': brandingInverted
        };
        if ( customClass ) {
            styles[ customClass ] = true;
        }

        return (
            <a
                className={ classNames( styles ) }
                onClick={ this.handleClick }
                tabIndex={tabIndex}
                { ...props }
            >
                { isFetching ?
                    <div role="presentation" className="loader-container spinning">
                        <RefreshIcon />
                    </div>
                :
                    done ?
                        <div role="presentation" className="loader-container done">
                            <CheckmarkCircleIcon/>
                        </div>
                    :
                        children
                }
            </a>
        );
    }
}
